module.exports = __webpack_public_path__ + "static/img/netflix-faq-error.cd3a79a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/netflix-faq-error.png
// module id = 1078
// module chunks = 1